import { FormControl, InputLabel, TextField } from "@mui/material";
import Badge from "@mui/material/Badge";
import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";

import blueLeftArrow from "../../assets/icons/basketMix/blue-left-arrow.svg";
import redRightArrow from "../../assets/icons/basketMix/red-right-arrow.svg";
import handDrag from "../../assets/icons/hand-drag.png";
import Card from "../../components/Cards/Card";
import Venn from "../../components/Charts/Venn";
import ComboHeader from "../../components/ComboHeader/ComboHeader";
import Modal from "../../components/Modal/Modal";
import NativeObject from "../../components/NativeObject/NativeObject";
import TooltipInfo from "../../components/TooltipInfo/TooltipInfo";
import { useQlik } from "../../context/Qlik";
import { useSelections } from "../../context/Selections";
import AnalisePdv from "./Modais/AnalisePdv";
import ConjuntosBasket from "./Modais/ConjuntosBasket";

const VennWrapper = styled.div`
  width: 100%;
  display: grid;
  margin: 10px;
  gap: 20px;
  grid-template-columns: 2fr 3fr 2fr;
`;

const ConjuntoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 230px;
`;

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;

  flex-direction: column;
  padding: 8px 0px;
  justify-content: center;
  .primaryButton .pdv {
    width: 100%;
    align-items: center;
    justify-content: center;
  }
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "space-evenly",
  width: "100%",
});

const LayoutCardWrapper = styled("div")({
  borderRadius: "16px",
  display: "flex",
  width: "100%",
  height: "48%",
  flexGrow: 1,
  paddingRight: "10px",
  ".card": {
    margin: 0,
  },
});

const StyledBadge = styled(Badge)(() => ({
  "& .MuiBadge-badge": {
    right: 5,
    top: 4,
    border: `2px solid #38bc9a`,
    background: "#38bc9a",
    padding: "0 4px",
  },
}));

function BasketMixDesktop({ app, config }) {
  const [valueInputA, setValueInputA] = useState(0);
  const [valueInputB, setValueInputB] = useState(0);

  const [vSelloutPR, setVSelloutPR] = useState("");
  const [vSelloutUNDPR, setVSelloutUNDPR] = useState("");
  const [vPrecoMedioUNDPR, setVPrecoMedioUNDPR] = useState("");
  const [vPDVSCompradoresPR, setVPDVSCompradoresPR] = useState("");
  const [vVendedoresPR, setVVendedoresPR] = useState("");
  const [vTotalSKUPR, setVTotalSKUPR] = useState("");
  const [vOportunidadePR, setVOportunidadePR] = useState("");

  const [vSelloutOCS, setVSelloutOCS] = useState("");
  const [vSelloutCXOCS, setVSelloutCXOCS] = useState("");
  const [vPrecoMedioCXOCS, setVPrecoMedioCXOCS] = useState("");
  const [vPDVSCompradoresOCS, setVPDVSCompradoresOCS] = useState("");
  const [vVendedoresOCS, setVVendedoresOCS] = useState("");
  const [vTotalSKUOCS, setVTotalSKUOCS] = useState("");
  const [vOportunidadeOCS, setVOportunidadeOCS] = useState("");

  const [vFiltroGrupoA, setVFiltroGrupoA] = useState(0);
  const [vFiltroGrupoB, setVFiltroGrupoB] = useState(0);

  const [modalOpened, setModalOpened] = useState(false);
  const [modalOpenedPdvs, setModalOpenedPdvs] = useState(false);
  const conjuntoModal = useRef(0);
  const analiseModal = useRef(0);

  const { selections } = useSelections();
  const { setSwitchOnDemand } = useQlik();

  function initialDataTable() {
    app.variable.getContent("vFiltroGrupoA", (reply) => {
      const data = reply.qContent.qString;
      setVFiltroGrupoA(data);
    });
    app.variable.getContent("vFiltroGrupoB", (reply) => {
      const data = reply.qContent.qString;
      setVFiltroGrupoB(data);
    });
    app.variable.getContent("vSelloutPR", (reply) => {
      const data = reply.qContent.qString;
      setVSelloutPR(data);
    });
    app.variable.getContent("vSelloutUNDPR", (reply) => {
      const data = reply.qContent.qString;
      setVSelloutUNDPR(data);
    });
    app.variable.getContent("vPrecoMedioUNDPR", (reply) => {
      const data = reply.qContent.qString;
      setVPrecoMedioUNDPR(data);
    });
    app.variable.getContent("vPDVSCompradoresPR", (reply) => {
      const data = reply.qContent.qString;
      setVPDVSCompradoresPR(data);
    });
    app.variable.getContent("vVendedoresPR", (reply) => {
      const data = reply.qContent.qString;
      setVVendedoresPR(data);
    });
    app.variable.getContent("vTotalSKUPR", (reply) => {
      const data = reply.qContent.qString;
      setVTotalSKUPR(data);
    });
    app.variable.getContent("vOportunidadePR", (reply) => {
      const data = reply.qContent.qString;
      setVOportunidadePR(data);
    });

    app.variable.getContent("vSelloutOCS", (reply) => {
      const data = reply.qContent.qString;
      setVSelloutOCS(data);
    });
    app.variable.getContent("vSelloutCXOCS", (reply) => {
      const data = reply.qContent.qString;
      setVSelloutCXOCS(data);
    });
    app.variable.getContent("vPrecoMedioCXOCS", (reply) => {
      const data = reply.qContent.qString;
      setVPrecoMedioCXOCS(data);
    });
    app.variable.getContent("vPDVSCompradoresOCS", (reply) => {
      const data = reply.qContent.qString;
      setVPDVSCompradoresOCS(data);
    });
    app.variable.getContent("vVendedoresOCS", (reply) => {
      const data = reply.qContent.qString;
      setVVendedoresOCS(data);
    });
    app.variable.getContent("vTotalSKUOCS", (reply) => {
      const data = reply.qContent.qString;
      setVTotalSKUOCS(data);
    });
    app.variable.getContent("vOportunidadeOCS", (reply) => {
      const data = reply.qContent.qString;
      setVOportunidadeOCS(data);
    });
  }

  async function initialInputs() {
    await app.variable.getContent("vSimuladorA", (reply) => {
      const data = reply.qContent.qString;
      if (data !== undefined) {
        setValueInputA(parseInt(data, 10));
      }
    });
    await app.variable.getContent("vSimuladorB", (reply) => {
      const data = reply.qContent.qString;
      if (data !== undefined) {
        setValueInputB(parseInt(data, 10));
      }
    });
    await app.variable.setNumValue("vSimuladorSliderA", 0);
    await app.variable.setNumValue("vSimuladorSliderB", 0);
  }

  async function handleChangeInputA(event) {
    setValueInputA(event.target.value);
    if (app) {
      await app.variable.setNumValue(
        "vSimuladorA",
        parseInt(event.target.value, 10)
      );
    }
  }

  async function handleChangeInputB(event) {
    setValueInputB(event.target.value);
    if (app) {
      await app.variable.setNumValue(
        "vSimuladorB",
        parseInt(event.target.value, 10)
      );
    }
  }

  function showModal(index) {
    conjuntoModal.current = index;
    setModalOpened(true);
  }
  function showModalPdvs(index) {
    analiseModal.current = index;
    setModalOpenedPdvs(true);
  }

  function closeModal() {
    setModalOpened(false);
  }
  function closeModalPdvs() {
    setModalOpenedPdvs(false);
  }

  useEffect(() => {
    if (app) {
      initialInputs();
    }
  }, []);

  useEffect(() => {
    if (app) {
      initialDataTable();
    }
  }, [selections]);

  useEffect(() => {
    setSwitchOnDemand(false);
  });

  const ModalButton = ({ title, onClick, color, pdv, tooltip, valueBadge }) => (
    <ButtonWrapper>
      <div className="primaryButton pdv" aria-hidden="true" onClick={onClick}>
        {pdv ? (
          <button
            style={{
              width: "100%",
              height: "40px",
              background: color,
              color: "#fff",
            }}
            type="button"
          >
            <div
              className="row"
              style={{ alignItems: "center", justifyContent: "center" }}
            >
              <span>{title}</span>
              {tooltip && (
                <TooltipInfo
                  text={tooltip}
                  style={{ color: "#fff", marginLeft: "8px" }}
                />
              )}
            </div>
          </button>
        ) : (
          <StyledBadge
            color="success"
            badgeContent={valueBadge > 0 ? valueBadge : 0}
            max={9}
            style={{ width: "100%" }}
          >
            <button style={{ width: "100%", height: "40px" }} type="button">
              <div
                className="row"
                style={{
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span>{title}</span>
                <i style={{ color: color }} className="fas fa-chevron-down" />
              </div>
            </button>
          </StyledBadge>
        )}
      </div>
    </ButtonWrapper>
  );

  return (
    <div className="app basketMix">
      <div className="appContent">
        <LayoutCardsWrapper>
          <LayoutCardWrapper>
            {modalOpened && (
              <Modal
                title="Conjuntos"
                show={modalOpened}
                setShow={() => closeModal()}
                closeButton
              >
                <ConjuntosBasket
                  app={app}
                  config={config}
                  index={conjuntoModal.current}
                />
              </Modal>
            )}
            {modalOpenedPdvs && (
              <Modal
                title="Clientes não compradores"
                show={modalOpenedPdvs}
                setShow={() => closeModalPdvs()}
                closeButton
              >
                <AnalisePdv
                  app={app}
                  config={config}
                  index={analiseModal.current}
                />
              </Modal>
            )}
            <VennWrapper>
              {/* A */}
              <Card style={{ background: "#365698" }}>
                <ConjuntoWrapper
                  style={{
                    border: "1.09091px solid #F8F8F8",
                    boxShadow:
                      "0px 2.18182px 7.63636px rgba(194, 194, 194, 0.25)",
                    borderRadius: "4.36364px",
                    background: "#fff",
                    padding: "8px",
                    height: "40%",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "70px",
                      borderRadius: "5px 5px 0px 0px",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "row",
                      borderBottom: "1px solid #F3F1F1",
                    }}
                  >
                    <ComboHeader
                      reference={{
                        title: {
                          id: "header.titleId",
                          hard: "Pré-Requisito (PR)",
                        },
                      }}
                      tooltip="Pré-Requisito (Coluna Azul): Principal produto ou categoria que deseja usar como foco de comparação"
                    />
                  </div>
                  <div
                    style={{
                      borderBottom: "1px solid #F3F1F1",
                      marginBottom: "8px",
                    }}
                  >
                    <ModalButton
                      title="Selecione uma ou mais marcas"
                      onClick={() => showModal(0)}
                      color="#365698"
                      valueBadge={vFiltroGrupoA}
                    />
                  </div>

                  <div
                    style={{
                      display: "grid",
                      gridTemplateRows: "repeat(7, 1fr)",
                      rowGap: "8px",
                    }}
                    className="listRsultados"
                  >
                    <div>
                      <h3>Sell Out (R$)</h3>
                      <h4>{vSelloutPR}</h4>
                    </div>
                    <div>
                      <h3>Sell Out (Cx)</h3>
                      <h4>{vSelloutUNDPR}</h4>
                    </div>
                    <div>
                      <h3>Preço Médio (Cx)</h3>
                      <h4>{vPrecoMedioUNDPR}</h4>
                    </div>
                    <div>
                      <h3>Clientes Compradores</h3>
                      <h4>{vPDVSCompradoresPR}</h4>
                    </div>
                    <div>
                      <h3>Vendedores</h3>
                      <h4>{vVendedoresPR}</h4>
                    </div>
                    <div>
                      <h3>Total de itens (SKUs)</h3>
                      <h4>{vTotalSKUPR}</h4>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexLDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <h2>Clientes com Oportunidade</h2>
                    <h3 style={{ fontWeight: "600", color: "#000" }}>
                      {vOportunidadePR}
                    </h3>
                  </div>
                </ConjuntoWrapper>
                <ConjuntoWrapper
                  style={{
                    boxShadow:
                      "0px 2.18182px 7.63636px rgba(194, 194, 194, 0.25)",
                    borderRadius: "4.36364px",
                    background: "#fff",
                    height: "58%",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "40%",
                      borderTopLeftRadius: "4.36364px",
                      borderTopRightRadius: "4.36364px",
                      padding: "8px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "40px",
                        borderRadius: "5px 5px 0px 0px",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "row",
                        borderBottom: "1px solid #F3F1F1",
                        marginBottom: "8px",
                      }}
                    >
                      <ComboHeader
                        reference={{
                          title: {
                            id: "subtitle?.hard",
                            hard: "Simular Oportunidade",
                          },
                        }}
                        tooltip="Simule uma estimativa de volume médio em unidades para clientes com oportunidade de positivação com Itens PR"
                      />
                    </div>

                    <div className="hideTitleSlider">
                      <NativeObject
                        app={app}
                        reference={{ id: "DNpSxvj" }}
                        style={{
                          width: "100%",
                          height: "50px",
                        }}
                      />
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <img src={handDrag} alt="mova o slider" />
                        <span>
                          Escolha o percentual de clientes com oportunidades
                        </span>
                        <TooltipInfo
                          text="Slider para escolher percentual de captura em clientes com oportunidade"
                          style={{ marginLeft: "8px" }}
                        />
                      </div>
                    </div>
                    <div style={{ marginTop: "16px" }}>
                      <FormControl>
                        <InputLabel htmlFor="component-outlined"></InputLabel>
                        <TextField
                          id="component-outlined"
                          size="small"
                          label="Digite o Volume desejado (Cx)"
                          fullWidth
                          defaultValue={valueInputA}
                          onBlur={handleChangeInputA}
                          type="number"
                        />
                      </FormControl>
                    </div>
                  </div>
                  <div
                    className="titleKpiSimulador"
                    style={{
                      background: "#ebf3fb",
                      width: "100%",
                      height: "60%",

                      borderBottomLeftRadius: "4.36364px",
                      borderBottomRightRadius: "4.36364px",
                    }}
                  >
                    <div
                      style={{
                        background: "#ebf3fb",
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          background: "#ebf3fb",
                          width: "50%",
                          padding: "8px",
                        }}
                      >
                        <Card>
                          <NativeObject
                            app={app}
                            reference={{ id: "UWnrVG" }}
                            style={{
                              width: "100%",
                              height: "40px",
                            }}
                          />
                        </Card>
                      </div>
                      <div
                        style={{
                          background: "#ebf3fb",
                          width: "50%",
                          padding: "8px",
                        }}
                      >
                        <Card>
                          <NativeObject
                            app={app}
                            reference={{ id: "wFFzJqa" }}
                            style={{
                              width: "100%",
                              height: "40px",
                            }}
                          />
                        </Card>
                      </div>
                    </div>
                    <div
                      style={{
                        background: "#ebf3fb",
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          background: "#ebf3fb",
                          width: "50%",
                          padding: "8px",
                        }}
                      >
                        {/* <Card tooltipKpi="Visualize o resultado da simulação"> */}
                        <Card>
                          <NativeObject
                            app={app}
                            reference={{ id: "XRJTUv" }}
                            style={{
                              width: "100%",
                              height: "40px",
                            }}
                          />
                        </Card>
                      </div>
                      <div
                        style={{
                          background: "#ebf3fb",
                          width: "50%",
                          padding: "8px",
                        }}
                      >
                        <Card>
                          <NativeObject
                            app={app}
                            reference={{ id: "npAVpp" }}
                            style={{
                              width: "100%",
                              height: "40px",
                            }}
                          />
                        </Card>
                      </div>
                    </div>
                    <div
                      style={{
                        background: "#ebf3fb",
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        padding: "8px",
                      }}
                    >
                      <ModalButton
                        title="Visualizar clientes"
                        onClick={() => showModalPdvs(0)}
                        color="#4B81D0"
                        pdv
                        tooltip="Visualize a listagem de clientes com oportunidade de positivação com Itens PR"
                      />
                    </div>
                  </div>
                </ConjuntoWrapper>
              </Card>
              {/* VENN */}
              {vFiltroGrupoA > 0 && vFiltroGrupoB > 0 ? (
                <Card>
                  <div
                    style={{
                      marginTop: "12px",
                      borderBottom: "1px solid #F3F1F1",
                      marginBottom: "8px",
                    }}
                  >
                    <ComboHeader
                      reference={{
                        title: {
                          id: "header.titleId",
                          hard: "Clientes compradores de PR vs OCS",
                        },
                      }}
                      tooltip="No gráfico de círculos temos uma visão de totais de clientes que compraram apenas o PRODUTO A (lado azul), que compraram PRODUTO A+B (centro - azul/laranja) e que compraram apenas PRODUTO B (lado laranja)."
                    />
                  </div>

                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "60%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                      }}
                    >
                      <Venn
                        app={app}
                        reference={{ id: "yXeJ" }}
                        style={{
                          flex: 1,
                          display: "flex",
                          alignItems: "center",
                          width: "100% !important",
                        }}
                      />
                    </div>
                    <div
                      style={{
                        width: "100%",
                        height: "50%",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          height: "40px",
                          color: "#fff",
                          display: "grid",
                          alignItems: "center",
                          gridTemplateColumns: "1fr 1fr 1fr",
                          justifyItems: "center",
                          background:
                            "linear-gradient(90deg, #365698 33%, #947C92 33% 66%, #F6540E 66% 100%)",
                        }}
                      >
                        <span>PR</span>
                        <span>PR e OCS</span>
                        <span>OCS</span>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          height: "80%",
                          marginTop: "10px",
                          display: "grid",
                          alignItems: "center",
                          gridTemplateColumns: "1fr 1fr 1fr",
                          justifyItems: "center",
                        }}
                      >
                        <div
                          style={{
                            height: "100%",
                            width: "100%",
                            justifyContent: "center",
                          }}
                        >
                          <i
                            style={{
                              color: "#365698",
                              fontSize: "40px",
                              width: "100%",
                              display: "flex",
                              justifyContent: "center",
                            }}
                            className="fas fa-square h-4 "
                          />
                          <NativeObject
                            app={app}
                            reference={{ id: "jBQXGBh" }}
                            style={{
                              width: "100%",
                              height: "50%",
                              margin: "20px, 0px",
                            }}
                          />
                          <NativeObject
                            app={app}
                            reference={{ id: "kWpAmL" }}
                            style={{
                              width: "100%",
                              height: "50%",
                            }}
                          />
                        </div>
                        <div
                          style={{
                            height: "100%",
                            width: "100%",
                            justifyContent: "center",
                          }}
                        >
                          <i
                            style={{
                              color: "#947C92",
                              fontSize: "40px",
                              width: "100%",
                              display: "flex",
                              justifyContent: "center",
                            }}
                            className="fas fa-square"
                          />
                          <NativeObject
                            app={app}
                            reference={{ id: "tuNWd" }}
                            style={{
                              width: "100%",
                              height: "50%",
                            }}
                          />
                          <NativeObject
                            app={app}
                            reference={{ id: "ExaGmZ" }}
                            style={{
                              width: "100%",
                              height: "50%",
                            }}
                          />
                        </div>
                        <div
                          style={{
                            height: "100%",
                            width: "100%",
                            justifyContent: "center",
                          }}
                        >
                          <i
                            style={{
                              color: "#F6540E",
                              fontSize: "40px",
                              width: "100%",
                              display: "flex",
                              justifyContent: "center",
                            }}
                            className="fas fa-square"
                          />
                          <NativeObject
                            app={app}
                            reference={{ id: "wDmdxZH" }}
                            style={{
                              width: "100%",
                              height: "50%",
                            }}
                          />
                          <NativeObject
                            app={app}
                            reference={{ id: "ByUwPF" }}
                            style={{
                              width: "100%",
                              height: "50%",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Card>
              ) : (
                <Card style={{ marginTop: "80px", height: "30%" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      height: "10%",
                      justifyContent: "space-between",
                      marginBottom: "30px",
                    }}
                  >
                    <div>
                      <img src={blueLeftArrow} alt="blue-left-arrow" />
                    </div>
                    <div>
                      <img src={redRightArrow} alt="red-right-arrow" />
                    </div>
                  </div>
                  <div>
                    <div>
                      <span
                        style={{
                          fontSize: "16px",
                          textAlign: "center",
                          display: "block",
                          justifyContent: "center",
                        }}
                      >
                        Todas as comparações realizadas nestes gráficos e
                        relatórios serão referenciadas pelas seleções ao lado;
                        as seleções em{" "}
                        <span style={{ color: "#365698", fontWeight: "bold" }}>
                          azul
                        </span>{" "}
                        chamaremos de{" "}
                        <span style={{ color: "#365698", fontWeight: "bold" }}>
                          PR (à esquerda)
                        </span>{" "}
                        e as seleções em{" "}
                        <span style={{ color: "#F6540E", fontWeight: "bold" }}>
                          laranja
                        </span>{" "}
                        chamaremos de{" "}
                        <span style={{ color: "#F6540E", fontWeight: "bold" }}>
                          OCS (à direita)
                        </span>
                        .<br></br>
                        <br></br>
                        <span style={{ color: "black", fontWeight: "bold" }}>
                          Atente para os gráficos e veja que todos possuem as
                          cores referenciando às seleções. Para o uso do Basket
                          Analysis, estas seleções são obrigatórias.
                        </span>
                      </span>
                    </div>
                  </div>
                </Card>
              )}

              {/* B */}
              <Card style={{ background: "#F6540E" }}>
                <ConjuntoWrapper
                  style={{
                    border: "1.09091px solid #F8F8F8",
                    boxShadow:
                      "0px 2.18182px 7.63636px rgba(194, 194, 194, 0.25)",
                    borderRadius: "4.36364px",
                    background: "#fff",
                    padding: "8px",
                    height: "40%",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "70px",
                      borderRadius: "5px 5px 0px 0px",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "row",
                      borderBottom: "1px solid #F3F1F1",
                    }}
                  >
                    <ComboHeader
                      reference={{
                        title: {
                          id: "header.titleId",
                          hard: "Cross-Selling (OCS)",
                        },
                      }}
                      tooltip="Cross-Selling (Coluna Laranja): Produto ou categoria que deseja comparar com pré-requisito. Por exemplo, um produto que queira aumentar a penetração. "
                    />
                  </div>
                  <div
                    style={{
                      borderBottom: "1px solid #F3F1F1",
                      marginBottom: "8px",
                    }}
                  >
                    <ModalButton
                      title="Selecione uma ou mais marcas"
                      onClick={() => showModal(1)}
                      color="#F6540E"
                      valueBadge={vFiltroGrupoB}
                    />
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateRows: "repeat(7, 1fr)",
                      rowGap: "8px",
                    }}
                    className="listRsultados"
                  >
                    <div>
                      <h3>Sell Out (R$)</h3>
                      <h4>{vSelloutOCS}</h4>
                    </div>
                    <div>
                      <h3>Sell Out (Cx)</h3>
                      <h4>{vSelloutCXOCS}</h4>
                    </div>
                    <div>
                      <h3>Preço Médio (Cx)</h3>
                      <h4>{vPrecoMedioCXOCS}</h4>
                    </div>
                    <div>
                      <h3>Clientes Compradores</h3>
                      <h4>{vPDVSCompradoresOCS}</h4>
                    </div>
                    <div>
                      <h3>Vendedores</h3>
                      <h4>{vVendedoresOCS}</h4>
                    </div>
                    <div>
                      <h3>Total de itens (SKUs)</h3>
                      <h4>{vTotalSKUOCS}</h4>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexLDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <h2>Clientes com Oportunidade</h2>
                    <h3 style={{ fontWeight: "600", color: "#000" }}>
                      {vOportunidadeOCS}
                    </h3>
                  </div>
                </ConjuntoWrapper>
                <ConjuntoWrapper
                  style={{
                    boxShadow:
                      "0px 2.18182px 7.63636px rgba(194, 194, 194, 0.25)",
                    borderRadius: "4.36364px",
                    background: "#fff",
                    height: "58%",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "40%",
                      borderTopLeftRadius: "4.36364px",
                      borderTopRightRadius: "4.36364px",
                      padding: "8px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "40px",
                        borderRadius: "5px 5px 0px 0px",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "row",
                        borderBottom: "1px solid #F3F1F1",
                        marginBottom: "8px",
                      }}
                    >
                      <ComboHeader
                        reference={{
                          title: {
                            id: "header.titleId",
                            hard: "Simular Oportunidade",
                          },
                        }}
                        tooltip="Simule uma estimativa de volume médio em unidades para clientes com oportunidade de positivação com Itens OCS"
                      />
                    </div>

                    <div className="hideTitleSlider">
                      <NativeObject
                        app={app}
                        reference={{ id: "LpyWfEj" }}
                        style={{
                          width: "100%",
                          height: "50px",
                        }}
                      />
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <img src={handDrag} alt="mova o slider" />
                        <span>
                          Escolha o percentual de clientes com oportunidades
                        </span>
                        <TooltipInfo
                          text="Slider para escolher percentual de captura em clientes com oportunidade"
                          style={{ marginLeft: "8px" }}
                        />
                      </div>
                    </div>
                    <div style={{ marginTop: "16px" }}>
                      <FormControl>
                        <InputLabel htmlFor="component-outlined"></InputLabel>
                        <TextField
                          id="component-outlined"
                          size="small"
                          label="Digite o Volume desejado (Cx)"
                          fullWidth
                          defaultValue={valueInputB}
                          onBlur={handleChangeInputB}
                          type="number"
                        />
                      </FormControl>
                    </div>
                  </div>
                  <div
                    className="titleKpiSimulador"
                    style={{
                      background: "#ebf3fb",
                      width: "100%",
                      height: "60%",

                      borderBottomLeftRadius: "4.36364px",
                      borderBottomRightRadius: "4.36364px",
                    }}
                  >
                    <div
                      style={{
                        background: "#ebf3fb",
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          background: "#ebf3fb",
                          width: "50%",
                          padding: "8px",
                        }}
                      >
                        <Card>
                          <NativeObject
                            app={app}
                            reference={{ id: "WvJzh" }}
                            style={{
                              width: "100%",
                              height: "40px",
                            }}
                          />
                        </Card>
                      </div>
                      <div
                        style={{
                          background: "#ebf3fb",
                          width: "50%",
                          padding: "8px",
                        }}
                      >
                        <Card>
                          <NativeObject
                            app={app}
                            reference={{ id: "FBRpwx" }}
                            style={{
                              width: "100%",
                              height: "40px",
                            }}
                          />
                        </Card>
                      </div>
                    </div>
                    <div
                      style={{
                        background: "#ebf3fb",
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          background: "#ebf3fb",
                          width: "50%",
                          padding: "8px",
                        }}
                      >
                        {/* <Card tooltipKpi="Visualize o resultado da simulação"> */}
                        <Card>
                          <NativeObject
                            app={app}
                            reference={{ id: "EmPheS" }}
                            style={{
                              width: "100%",
                              height: "40px",
                            }}
                          />
                        </Card>
                      </div>
                      <div
                        style={{
                          background: "#ebf3fb",
                          width: "50%",
                          padding: "8px",
                        }}
                      >
                        <Card>
                          <NativeObject
                            app={app}
                            reference={{ id: "FmNGYJq" }}
                            style={{
                              width: "100%",
                              height: "40px",
                            }}
                          />
                        </Card>
                      </div>
                    </div>
                    <div
                      style={{
                        background: "#ebf3fb",
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        padding: "8px",
                      }}
                    >
                      <ModalButton
                        title="Visualizar Clientes"
                        onClick={() => showModalPdvs(1)}
                        color="#F6540E"
                        pdv
                        tooltip="Visualize a listagem de clientes com oportunidade de positivação com Itens OCS"
                      />
                    </div>
                  </div>
                </ConjuntoWrapper>
              </Card>
            </VennWrapper>
          </LayoutCardWrapper>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

BasketMixDesktop.defaultProps = {
  app: null,
  config: {},
};

BasketMixDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default BasketMixDesktop;
